import { Control, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DateFormField, NumericFormField, OptionalNumericFormField, TextFormField } from '@/components';

export type PlotPortfolioSubscriptionFormValues = {
  display_name: string;
  start_date: string;
  end_date: string;
  initial_setup_cost_credits: string;
  plot_creation_cost_credits: string;
  max_plots: string;
  max_hectares: string;
};

export const PlotPortfolioSubscriptionFormFields = ({
  control,
}: {
  control: Control<PlotPortfolioSubscriptionFormValues>;
}) => {
  const { t } = useTranslation();
  const invalidNumberMessage = t('shared.ndiOrganizationSubscriptions.formRules.invalidNumber');
  const noLimitPlaceholder = t('shared.ndiProducts.noLimit');
  const startDate = useWatch({ control, name: 'start_date' });

  return (
    <>
      <TextFormField
        control={control}
        name='display_name'
        label={t('shared.ndiOrganizationSubscriptions.fields.displayName')}
      />
      <DateFormField
        control={control}
        name='start_date'
        label={t('shared.ndiOrganizationSubscriptions.fields.startDate')}
      />
      <DateFormField
        control={control}
        name='end_date'
        label={t('shared.ndiOrganizationSubscriptions.fields.endDate')}
        min={startDate || undefined}
      />
      <NumericFormField
        control={control}
        name='initial_setup_cost_credits'
        label={t('shared.ndiProducts.fields.initialSetupCostCredits')}
        invalidNumberMessage={invalidNumberMessage}
      />
      <NumericFormField
        control={control}
        name='plot_creation_cost_credits'
        label={t('shared.ndiProducts.fields.plotCreationCostCredits')}
        invalidNumberMessage={invalidNumberMessage}
      />
      <OptionalNumericFormField
        control={control}
        name='max_plots'
        label={t('shared.ndiProducts.fields.maxPlots')}
        invalidNumberMessage={invalidNumberMessage}
        placeholder={noLimitPlaceholder}
      />
      <OptionalNumericFormField
        control={control}
        name='max_hectares'
        label={t('shared.ndiProducts.fields.maxHectares')}
        invalidNumberMessage={invalidNumberMessage}
        placeholder={noLimitPlaceholder}
      />
    </>
  );
};
